// const baseDomainOrderManagement = 'https://qsr-login-service.staging.k8s.neontech.cloud/';
// const baseDomainUserManagement = 'https://qsr-login-service.staging.k8s.neontech.cloud/';
// const baseDomainLabManagement = '';
// const baseDomainLogin = 'https://qsr-login-service.staging.k8s.neontech.cloud/';
// const baseDomainScheduleManagement = 'https://qsr-login-service.staging.k8s.neontech.cloud/';
// const baseDomainDashboardManagement = 'https://qsr-login-service.staging.k8s.neontech.cloud/';

const BASE = process.env.REACT_APP_BASE_URL || '';
const AUTH_SERVICE = `${BASE}/auth`;
const ORDER_SERVICE_API = `${BASE}/api`;
const ORDER_MANAGEMENT_SERVICE = `${ORDER_SERVICE_API}/order-management-service`;
const USER_MANAGEMENT_SERVICE = `${BASE}/api/user-management-service`;

export default {
  base: BASE, // 'http://192.168.31.51:3001',

  // auth
  login: `${AUTH_SERVICE}/login`,
  logout: `${AUTH_SERVICE}/logout`,
  resetPassword: `${AUTH_SERVICE}/resetPassword`,
  checkResetPasswordSessionToken: `${AUTH_SERVICE}/checkResetPasswordSessionToken`,
  forgotPassword: `${AUTH_SERVICE}/forgotPassword`,
  refreshToken: `${AUTH_SERVICE}/refreshtoken`,

  // user
  getAllUser: () => `${USER_MANAGEMENT_SERVICE}/getAllUser`,
  addUser: () => `${USER_MANAGEMENT_SERVICE}/addUser`,
  deleteUser: () => `${USER_MANAGEMENT_SERVICE}/deleteUser`,
  sendPassword: () => `${USER_MANAGEMENT_SERVICE}/sendPassword`,
  sendResetPasswordLink: () => `${USER_MANAGEMENT_SERVICE}/sendPasswordResetLink`,
  getFilteredUser: () => `${USER_MANAGEMENT_SERVICE}/FilterOption`,

  // app
  getAllZones: () => `${ORDER_MANAGEMENT_SERVICE}/zone/getAllZones`,
  getAllCity: () => `${ORDER_MANAGEMENT_SERVICE}/city/getAllCity`,
  getCityByZone: () => `${ORDER_MANAGEMENT_SERVICE}/city/getCityByZone`,
  addNewZone: () => `${ORDER_MANAGEMENT_SERVICE}/zone/addNewZone`,
  addNewCity: () => `${ORDER_MANAGEMENT_SERVICE}/city/addNewCity`,

  // dashboard
  getDashboardData: () => `${ORDER_MANAGEMENT_SERVICE}/dashboard/employers`,

  // candidates
  getAllCandidates: () => `${ORDER_MANAGEMENT_SERVICE}/manage-candidate/getAllCandidates`,
  getCandidate: () => `${ORDER_MANAGEMENT_SERVICE}/manage-candidate/getCandidateById`,
  getFilteredCandidates: () => `${ORDER_MANAGEMENT_SERVICE}/manage-candidate/filterOption`,
  downloadCandidateExcel: () => `${ORDER_MANAGEMENT_SERVICE}/manage-candidate/downloadCandidateExcel`,
  downloadAllCandidates: () => `${ORDER_MANAGEMENT_SERVICE}/manage-candidate/downloadAllCandidates`,
  uploadCandidateExcel: () => `${ORDER_MANAGEMENT_SERVICE}/manage-candidate/processData`,
  // getAllCandidates: () => '/api/employers/zone/candidates',
  addNewCandidates: () => `${ORDER_MANAGEMENT_SERVICE}/manage-candidate/addNewCandidates`,
  editCandidate: () => `${ORDER_MANAGEMENT_SERVICE}/manage-candidate/editCandidate`,
  updateStatus: () => `${ORDER_MANAGEMENT_SERVICE}/manage-candidate/updateStatus`,

  // checkup
  getAllQsrCheckups: () => `${ORDER_MANAGEMENT_SERVICE}/checkupStatus/getAllQsrCheckups`,
  downloadCheckupStatusExcel: () => `${ORDER_MANAGEMENT_SERVICE}/checkupStatus/downloadCheckupStatusExcel`,
  updateCheckupStatus: () => `${ORDER_MANAGEMENT_SERVICE}/checkupStatus/checkupStatusUpdate`,
  resendCheckupSMS: () => `${ORDER_MANAGEMENT_SERVICE}/checkupStatus/smsResend`,
  getFilteredCheckupStatus: () => `${ORDER_MANAGEMENT_SERVICE}/checkupStatus/FilterOptionForCheckupStatus`,

  // reports
  getAllReports: () => `${ORDER_MANAGEMENT_SERVICE}/reports/getAllReports`,
  getFilteredReports: () => `${ORDER_MANAGEMENT_SERVICE}/reports/filterReports`,
  downloadReport: () => `${ORDER_MANAGEMENT_SERVICE}/reports/downloadReports`,
  downloadFilteredReports: () => `${ORDER_MANAGEMENT_SERVICE}/reports/downloadFilterReports`,
  downloadCandidatesReports: () => `${ORDER_MANAGEMENT_SERVICE}/reports/candidates/reports`,

  // schedule-checkup
  getFilteredScheduleCheckups: () => `${ORDER_MANAGEMENT_SERVICE}/schedule-checkup/FilterOption`,
  getAllScheduleCheckup: () => `${ORDER_MANAGEMENT_SERVICE}/schedule-checkup/getAllScheduleCheckup`,
  downloadScheduleCheckupExcel: () => `${ORDER_MANAGEMENT_SERVICE}/schedule-checkup/downloadScheduleCheckupExcel`,
  updateScheduleCheckupStatus: () => `${ORDER_MANAGEMENT_SERVICE}/schedule-checkup/updateScheduleCheckupStatus`,

  // stores
  addStore: () => `${ORDER_MANAGEMENT_SERVICE}/stores/store/add`,
  getStores: () => `${ORDER_MANAGEMENT_SERVICE}/stores/getStores`,
  getStoresDetails: () => `${ORDER_MANAGEMENT_SERVICE}/stores/getStoresDetails`,
};
